<template>
  <div class="progress atb-flex atb-flex-column">
    <div class="quick-search atb-flex">
      <!-- <div class="search-card plan atb-content-bg atb-flex atb-flex-items-center" @click="getListByCompleteStatus('plan')">
        <div class="num">
          {{ summary.plan || 0 }}
        </div>
        <div class="text">
          <h2>计划工作(个)</h2>
          <p>截止当前数据</p>
        </div>
      </div> -->
      <div class="search-card working atb-content-bg atb-flex atb-flex-items-center" @click="getListByCompleteStatus('processing')">
        <div class="num">
          {{ summary.processing || 0 }}
        </div>
        <div class="text">
          <h2>未完成工作(个)</h2>
          <p>截止当前数据</p>
        </div>
      </div>
      <div class="search-card delay atb-content-bg atb-flex atb-flex-items-center" @click="getListByCompleteStatus('delayed')">
        <div class="num">
          {{ summary.delayed || 0 }}
        </div>
        <div class="text">
          <h2>工作延迟数(个)</h2>
          <p>截止当前数据</p>
        </div>
      </div>
      <div class="search-card transfer atb-content-bg atb-flex atb-flex-items-center" @click="getListByCompleteStatus('transferred')">
        <div class="num">
          {{ summary.transferred || 0 }}
        </div>
        <div class="text">
          <h2>转移他人(个)</h2>
          <p>截止当前数据</p>
        </div>
      </div>
      <div class="search-card complete atb-content-bg atb-flex atb-flex-items-center" @click="getListByCompleteStatus('completed')">
        <div class="num">
          {{ summary.completed || 0 }}
        </div>
        <div class="text">
          <h2>完成工作(个)</h2>
          <p>截止当前数据</p>
        </div>
      </div>
    </div>
    <div class="atb-content-bg table-content atb-flex atb-flex-column">
      <div class="search">
        <el-form :inline="true" :model="searchParam" class="atb-input" @keyup.enter.native="getList(1)" @submit.native.prevent>
          <div class="flex-wrap">
            <el-form-item class="flex-form-item" label="关键字">
              <el-input v-model="searchParam.WorkItemContent" placeholder="工作项目" clearable></el-input>
            </el-form-item>
            <el-form-item class="flex-form-item" label="工作属性">
              <el-select clearable v-model="searchParam.Type" placeholder="工作属性">
                <el-option v-for="item in Type" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="flex-form-item" label="筛选范围">
              <common-select
                ref="WorkClassify"
                v-model="searchParam.WorkClassify"
                :list="workClassifyFilterList"
                optLabel="itemDesc"
                optValue="itemValue"
                placeholder="筛选范围"
                clearable
              ></common-select>
            </el-form-item>
            <el-form-item class="flex-form-item" label="完成情况">
              <common-select
                ref="CompleteStatus"
                v-model="searchParam.CompleteStatus"
                :list="searchCompleteList"
                optLabel="itemDesc"
                optValue="itemValue"
                clearable
                placeholder="完成情况"
              ></common-select>
            </el-form-item>
          </div>
          <div>
            <el-form-item class="flex-form-item" label="完成时间">
              <el-date-picker
                v-model="searchParam.FinishDate"
                unlink-panels
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
            <el-form-item class="flex-form-item">
              <el-checkbox v-model="searchParam.IsAllHistory">所有历史</el-checkbox>
            </el-form-item>
            <el-form-item class="flex-form-item">
              <el-button type="primary" @click="getList(1)">查询</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="table-content">
        <vxe-table
          stripe
          auto-resize
          class="atb-table"
          border="inner"
          ref="progress"
          height="100%"
          highlight-hover-row
          :data="tableData"
          @cell-click="expandRow"
          @sort-change="sortChange"
          :edit-config="{ trigger: 'click', mode: 'cell', showIcon: false }"
        >
          <!-- <vxe-table-column type="seq" width="50" title="NO."></vxe-table-column> -->
          <vxe-table-column field="title" title="标题" min-width="120px">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.title }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="workClassify" title="工作分类" min-width="120px" sortable>
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ workClassifyName(row) }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="workItemCategory" title="类别" min-width="100px">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.workItemCategory }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="workItemContent" min-width="140px" title="工作项目">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.workItemContent }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="currentTarget" min-width="140px" title="当前目标">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.currentTarget }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="currentFinishDate" min-width="160px" title="当前目标完成时间">
            <template #default="{row}">
              <span>{{ row.currentFinishDate ? XEUtils.toDateString(new Date(row.currentFinishDate), 'yyyy-MM-dd') : '' }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="wholeTarget" min-width="140px" title="总目标">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.wholeTarget }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="finishDate" min-width="160px" title="总目标完成时间" sortable>
            <template #default="{row}">
              <span>{{ row.finishDate ? XEUtils.toDateString(new Date(row.finishDate), 'yyyy-MM-dd') : '' }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="type" title="工作属性" min-width="80px">
            <template #default="{row}">
              <span>{{ Type.find((t) => t.value === row.type).label }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="completeStatus" min-width="120px" title="完成情况" sortable>
            <template #default="{ row }">
              <div v-if="row.type == 'yearwork'">
                <el-tag v-if="row.status !== 60" type="ongoing" effect="dark">
                  未完成
                </el-tag>
                <el-tag v-else type="complete" effect="dark">
                  已完成
                </el-tag>
              </div>
              <div v-else>
                <!-- <el-tag v-if="row.completeStatus === 0" type="plan" effect="dark">
                  计划
                </el-tag> -->
                <el-tag v-if="row.completeStatus === 10" type="ongoing" effect="dark">
                  未完成
                </el-tag>
                <!-- <el-tag v-if="row.completeStatus === 20" type="complete" effect="dark">
                  已完成
                </el-tag> -->
                <el-tag v-if="row.completeStatus === 20 && row.type == 'weekwork'" type="complete" effect="dark">
                  周目标已完成
                </el-tag>
                <el-tag v-if="row.completeStatus === 20 && row.type == 'monthwork'" type="complete" effect="dark">
                  月目标已完成
                </el-tag>
                <el-tag v-if="row.completeStatus === 25" type="complete" effect="dark">
                  总目标完成
                </el-tag>
                <el-tag v-if="row.completeStatus === 30" type="delay" effect="dark">
                  延迟
                </el-tag>
                <el-tag v-if="row.completeStatus === 40" type="transfer" effect="dark">
                  转移
                </el-tag>
                <el-tag v-if="row.completeStatus === 50" type="close" effect="dark">
                  关闭
                </el-tag>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="age" title="操作" min-width="160px" class-name="operation" fixed="right">
            <template #default="scope">
              <div>
                <el-tooltip
                  v-if="scope.row.type == 'yearwork' && (scope.row.status === 20 || scope.row.status === 40||scope.row.status===50||scope.row.status===70) && scope.row.currentTarget"
                  class="item"
                  effect="dark"
                  content="提交"
                  placement="bottom"
                >
                  <i class="icon-send" @click.stop="submitYearSummary(scope.row)"></i>
                </el-tooltip>
                <el-tooltip
                  v-else-if="(scope.row.status === 20 || scope.row.status === 50) && scope.row.currentTarget && scope.row.currentFinishDate"
                  class="item"
                  effect="dark"
                  content="提交"
                  placement="bottom"
                >
                  <i class="icon-send" @click.stop="submitMWSummary(scope.row)"></i>
                </el-tooltip>
                <el-tooltip v-if="isShowEdit(scope.row)" class="item" effect="dark" content="修订" placement="bottom">
                  <i class="icon-revise" @click.stop="changeTarget(scope.row, scope.rowIndex)"></i>
                </el-tooltip>
                <el-tooltip v-if="isShowTransferOrHandover(scope.row)" class='item' effect='dark' content='转移' placement="bottom">
                  <i class='icon-tubiao-91' @click.stop='transfer(scope.row, scope.rowIndex)'></i>
                </el-tooltip>
                <el-tooltip v-if="isShowTransferOrHandover(scope.row)" class='item' effect='dark' content='交接' placement="bottom">
                  <i class='icon-tubiao-92' @click.stop='handover(scope.row, scope.rowIndex)'></i>
                </el-tooltip>
              </div>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div class="page-con atb-flex atb-flex-justify-end">
        <vxe-pager
          background
          :current-page.sync="handledPage.PageIndex"
          :page-size.sync="handledPage.PageSize"
          :total="total"
          height="100%"
          @page-change="handlePageChange"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Total']"
        >
        </vxe-pager>
      </div>
      <el-dialog title="修订" v-if="showChange" :visible.sync="showChange" width="600px" custom-class="changeDialog" @close="closeCreate" :close-on-click-modal="false" :close-on-press-escape="false">
        <div class="content">
          <el-form ref="planForm" :model="form" label-width="95px" label-position="right" :rules="planRules">
            <el-form-item label="工作项分类" prop="workClassify">
              <el-select :disabled="ableClassify || form.source == 4" clearable v-model="form.workClassify" placeholder="工作项分类">
                <el-option v-for="item in workClassifyList" :key="item.itemValue" :label="item.itemDesc" :value="item.itemValue"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="类别" prop="workItemCategory">
              <el-autocomplete :disabled="form.source == 4" v-model="form.workItemCategory" :fetch-suggestions="queryCategory" placeholder="类别"></el-autocomplete>
            </el-form-item>
            <el-form-item label="责任人" prop="resWkName">
              <el-input v-model="form.resWkName" disabled placeholder="责任人"></el-input>
            </el-form-item>
            <el-form-item label="工作项目" prop="workItemContent">
              <el-input :disabled="form.source == 4" v-model="form.workItemContent" placeholder="工作项目" clearable></el-input>
            </el-form-item>
            <el-form-item label="总目标" prop="wholeTarget">
              <el-input :disabled="form.source == 4" type="textarea" v-model="form.wholeTarget" :rows="3" placeholder="总目标" clearable></el-input>
            </el-form-item>
            <el-form-item label="总目标完成时间" prop="finishDate">
              <el-date-picker :disabled="form.source == 4" v-model="form.finishDate" type="date" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="当前目标" prop="currentTarget">
              <el-input type="textarea" v-model="form.currentTarget" :rows="3" placeholder="当前目标" clearable></el-input>
            </el-form-item>
            <el-form-item label="完成情况" v-if="form.type !== 'yearwork'" prop="completeStatus">
              <el-select clearable v-model="form.completeStatus" placeholder="完成情况">
                <el-option :disabled="item.itemValue == 40" v-for="item in completeList" :key="item.itemValue" :label="item.itemDesc" :value="item.itemValue"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="form.type !== 'yearwork'" label="当前目标完成时间" prop="currentFinishDate">
              <el-date-picker v-model="form.currentFinishDate" type="date" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="权重" prop="weight">
              <el-autocomplete @change="regWeight(form)" v-model.trim="form.weight" :fetch-suggestions="weightSearch" clearable></el-autocomplete>
            </el-form-item>
            <el-form-item label="修订原因">
              <el-input type="textarea" v-model="form.modifyReason" :rows="3" placeholder="修订原因" clearable></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="atb-dialog-confirm" type="primary" @click="confirm">保存并发布</el-button>
          <el-button class="atb-dialog-cancel" type="cancel" @click="showChange = false">取消</el-button>
        </span>
      </el-dialog>
      <el-dialog title="提交总结" :visible.sync="showYearSummary" width="750px" custom-class="summaryDialog" :close-on-click-modal="false" :close-on-press-escape="false">
        <div class="content write-summary">
          <el-form :model="summaryForm" label-width="80px" class="atb-input" label-position="right" ref="yearSummaryForm" :rules="yearSummaryFormRules">
            <el-form-item v-if="summaryForm.status === 20||summaryForm.status===50" label="半年总结" prop="firstHalfSummary">
              <el-input type="textarea" v-model="summaryForm.firstHalfSummary" :rows="5" placeholder="半年总结" clearable></el-input>
            </el-form-item>
            <el-form-item v-if="summaryForm.status === 40||summaryForm.status===70" label="全年总结" prop="fullSummary">
              <el-input type="textarea" v-model="summaryForm.fullSummary" :rows="5" placeholder="全年总结" clearable></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="atb-dialog-confirm" type="primary" @click="submit">提交</el-button>
          <el-button class="atb-dialog-cancel" type="cancel" @click="showYearSummary = false">取消</el-button>
        </span>
      </el-dialog>
      <el-dialog title="提交总结" :visible.sync="showMWSummary" width="750px" custom-class="summaryDialog" :close-on-click-modal="false" :close-on-press-escape="false">
        <div class="content">
          <el-form :model="summaryForm" label-width="80px" label-position="right" ref="taskSummaryForm" :rules="taskSummaryFormRules">
            <el-form-item label="完成情况" prop="completeStatus">
              <el-select clearable  v-model="summaryForm.completeStatus" placeholder="完成情况">
                <el-option v-for="item in completeList" :disabled="item.itemValue == 40" :key="item.itemValue" :label="item.itemDesc" :value="item.itemValue"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="总结" prop="reason">
              <el-input type="textarea" v-model="summaryForm.reason" :rows="5" placeholder="总结" clearable></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="atb-dialog-confirm" type="primary" @click="submit">提交</el-button>
          <el-button class="atb-dialog-cancel" type="cancel" @click="showMWSummary = false">取消</el-button>
        </span>
      </el-dialog>
      <el-dialog :title="transferTitle" @close="closeTransfer" :visible.sync="showTransFer" width="500px" custom-class="transferDialog" :close-on-click-modal="false" :close-on-press-escape="false">
        <div class="content">
          <el-form ref="transferForm" :rules="rules" :model="transFerParam" label-width="80px" class="atb-input" label-position="right">
            <el-form-item label="指定人" prop="designeeNo">
              <selecter v-if="showTransFer" placeholder="指定人" v-model="transFerParam.designeeNo" @selecterData="getSelecterWkNameData"></selecter>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="atb-dialog-confirm" type="primary" @click="transFerOrHandover">提交</el-button>
          <el-button class="atb-dialog-cancel" type="cancel" @click="showTransFer = false">取消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import XEUtils from 'xe-utils';
import _ from 'lodash';

export default {
  name: 'index',
  components: {
    selecter: () => import('@/component/global/customerSelect'),
  },
  data() {
    let validateDesigneeNo = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请选择指定人'));
      }  else {
        callback();
      }
    };
    return {
      XEUtils: XEUtils,
      tableData: [],
      searchParam: {
        Type: 'all',
        OrderByFinishDate:'',
        OrderByCompleteStatus:0,
        OrderByWorkClassify:'',
        IsAllHistory: false
      },
      handledPage: {
        PageIndex: 1,
        PageSize: 10,
      },
      total: 0,
      completeList: [],
      weekCompleteList: [],
      monthCompleteList: [],
      yearStatusList: [{ label: '已完成', value: 60 }],
      summary: {},
      showChange: false,
      Type: [
        { label: '年', value: 'yearwork' },
        { label: '月', value: 'monthwork' },
        { label: '周', value: 'weekwork' },
        { label: '全部', value: 'all' },
      ],
      workClassifyList: [],
      form: {},
      expandRowFlag: false,
      defaultWorkClassify: [
        {
          itemValue: '0',
          itemDesc: 'KPI工作',
        },
      ],
      yearWorkClassify: [],
      monthWorkClassify: [],
      weekWorkClassify: [],
      categoryList: [],
      summaryForm: {},
      showYearSummary: false,
      showMWSummary: false,
      transferTitle: '转移工作',
      showTransFer: false,
      transFerParam: {
        workId: '',
        workItemIds: [],
        designeeNo: '',
        designeeName: '',
        workPlanType: 0,
        planType: 0,
      },
      seleterWkNameData: [],
      rules: {
        designeeNo: [{validator: validateDesigneeNo, trigger: 'change'}]
      },
      planRules: {
        workClassify: [
          { required: true, message: '工作项分类必填', trigger: 'change' },
        ],
        workItemContent: [
          { required: true, message: '工作项目必填', trigger: 'blur' },
          { max: 500, message: '最多500个字符', trigger: 'blur' }
        ],
        wholeTarget: [
          { required: true, message: '总目标必填', trigger: 'blur' },
          { max: 500, message: '最多500个字符', trigger: 'blur' }
        ],
        finishDate: [
          { required: true, message: '总目标完成时间必填', trigger: 'blur' },
          { max: 500, message: '最多500个字符', trigger: 'blur' }
        ],
        currentTarget: [
          { required: true, message: '当前目标必填', trigger: 'blur' },
          { max: 500, message: '最多500个字符', trigger: 'blur' }
        ],
        completeStatus: [
          { required: true, message: '完成情况必填', trigger: 'change' },
        ],
        currentFinishDate: [
          { required: true, message: '当前目标完成时间必填', trigger: 'change' },
        ],
        weight: [
          { required: true, message: '权重必填', trigger: 'change' },
        ]
      },
      yearSummaryFormRules:{
         firstHalfSummary: [
          { required: true, message: '半年总结必填', trigger: 'blur' },
          { max: 500, message: '最多500个字符', trigger: 'blur' }
        ],
         fullSummary: [
          { required: true, message: '全年总结必填', trigger: 'blur' },
          { max: 500, message: '最多500个字符', trigger: 'blur' }
        ],
      },
      taskSummaryFormRules:{
         completeStatus: [
          { required: true, message: '完成情况必填', trigger: 'change' },
        ],
         reason: [
          { required: true, message: '总结必填', trigger: 'blur' },
          { max: 500, message: '最多500个字符', trigger: 'blur' }
        ],
      },
      ableClassify: false,
      history: false,
      yearRowClassifyListNext: [],
    };
  },
  created() {},
  mounted() {
    this.getYearWorkClassify().then(()=>{
      this.getMonthWorkClassify().then(()=>{
        this.getWeekWorkClassify().then(()=>{
          this.getList(1);
        })
      });
    });
    this.getWeekWorkItemProcessStatus();
    this.getMonthWorkItemProcessStatus();
    this.getCategory();
  },
  computed: {
    workClassifyFilterList() {
      if (this.searchParam.Type === 'yearwork') {
        return this.yearWorkClassify;
      } else if (this.searchParam.Type === 'monthwork') {
        return this.monthWorkClassify;
      } else if (this.searchParam.Type === 'weekwork') {
        return this.weekWorkClassify;
      } else {
        return this.defaultWorkClassify;
      }
    },
    searchCompleteList() {
      if (this.searchParam.Type === 'yearwork') {
        let array = this.weekCompleteList.filter((t) => t.itemValue !== '50').concat([{itemValue:'1000',itemDesc:'已完成+总目标完成'}]);
        let array1 = [];
        array1 = _.cloneDeep(array);
        array1.forEach(v => {
          if (v.itemValue == 20) {
            v.itemDesc = "已完成"
          }
        });
        return array1;
      } else if (this.searchParam.Type === 'monthwork') {
        return this.monthCompleteList.filter((t) => t.itemValue !== '50').concat([{itemValue:'1000',itemDesc:'已完成+总目标完成'}]);
      } else if (this.searchParam.Type === 'weekwork') {
        return this.weekCompleteList.filter((t) => t.itemValue !== '50').concat([{itemValue:'1000',itemDesc:'已完成+总目标完成'}]);
      } else {
         let array = this.weekCompleteList.filter((t) => t.itemValue !== '50').concat([{itemValue:'1000',itemDesc:'已完成+总目标完成'}]);
          let array1 = [];
          array1 = _.cloneDeep(array);
          array1.forEach(v => {
          if (v.itemValue == 20) {
            v.itemDesc = "月/周目标完成"
          }
        });
        return array1;
      }
    }
  },
  methods: {
    regWeight(row) {
      console.log();
      let reg = new RegExp('^([1-9]|[1-9]\\d|100)$');
      if (!reg.test(row.weight)) {
        if (row.weight - 0 > 100) {
          row.weight = 100;
        } else {
          row.weight = 1;
        }
      }
    },
    getList(page) {
      this.handledPage.PageIndex = page;
      const queryWhere = _.cloneDeep(this.searchParam);
      if (queryWhere.FinishDate && queryWhere.FinishDate.length > 0) {
        queryWhere.StartDate = this.formatDate(this.searchParam.FinishDate[0], 'yyyy-MM-dd');
        queryWhere.EndDate = this.formatDate(this.searchParam.FinishDate[1], 'yyyy-MM-dd');
        delete queryWhere.FinishDate;
      }
      this.pageParams = { SkipCount: (this.handledPage.PageIndex - 1) * this.handledPage.PageSize, MaxResultCount: this.handledPage.PageSize };
      let param = Object.assign({}, queryWhere, this.pageParams);
      this.$ajax.get(this.$api.home.work.list, param).then((res) => {
        this.tableData = (res.data && res.data.rows.list) || [];
        this.summary = (res.data && res.data.rows.summary) || {};
        this.tableData.forEach((val) => {
          val.expandRowFlag = false;
        });
        this.total = (res.data && res.data.total) || 0;
      });
    },
    handlePageChange({ currentPage }) {
      this.getList(currentPage);
    },
    submit() {
      const params = this.summaryForm;
      if (params.type == 'yearwork') {
        this.$refs.yearSummaryForm.validate((valid) => {
          if (valid) {
            const paramObj =
              params.status == 20||params.status == 50
                ? { workId: params.workId, id: params.id, status: 35, firstHalfSummary: params.firstHalfSummary }
                : { workId: params.workId, id: params.id, status: 55, fullSummary: params.fullSummary };
            // 保存年总结
            const saveParam = _.omit(paramObj, ["status"]);
            this.$ajax.post(this.$api.year.yearWorkDetail.updateSummary, [saveParam]).then(() => {
              this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, [paramObj]).then(() => {
                this.getList(1);
                this.$message.success('提交成功');
                this.showYearSummary = false;
              });
            });
          }
        });
      } else if (params.type == 'monthwork') {
        this.$refs.taskSummaryForm.validate((valid) => {
          if (valid) {
            this.$ajax.put(this.$api.month.MonthWorkDetail.commitComplete, [
              {
                id: params.id,
                completeStatus: params.completeStatus,
                reason: params.reason,
              },
            ])
            .then(() => {
              this.getList(1);
              this.$message.success('提交成功');
              this.showMWSummary = false;
            });
          }
        });
      } else if (params.type == 'weekwork') {
        this.$refs.taskSummaryForm.validate((valid) => {
          if (valid) {
            this.$ajax.put(this.$api.week.WeekWorkDetail.commitComplete, [
              {
                id: params.id,
                completeStatus: params.completeStatus,
                reason: params.reason,
              },
            ])
            .then(() => {
              this.getList(1);
              this.$message.success('提交成功');
              this.showMWSummary = false;
            });
          }
        });
      }
    },
    getYearClassifyNext(row) {
      this.yearRowClassifyListNext = [];
      return this.$ajax.get(this.$api.transfer.yearClassifyNext, {workItemId: row.id}).then((res) => {
        if (res) {
          this.yearRowClassifyListNext = (res.data || []).filter(item => item.modifyType == 1).map(item => {
            return {
              itemDesc: item.classifyName,
              itemValue: item.workClassify + '',
            }
          });
        }
      });
    },
    changeTarget(row) {
      this.ableClassify = false;
      this.showChange = true;
      this.rowClone = _.cloneDeep(row);
      this.form = _.cloneDeep(row);
      if (this.form.type === 'yearwork') {
        if (row.version) {
          this.getYearClassifyNext(row).then(() => {
            this.workClassifyList = this.yearRowClassifyListNext;
          }).catch(() => {
            this.workClassifyList = this.yearWorkClassify.filter(t => t.itemValue == 0 || t.itemValue == 10 || t.itemValue == 50);
          });
        } else {
          if (this.form.workClassify != 0 && this.form.workClassify != 10 && this.form.workClassify != 50) {
            //人力 预算等工作不能修改分类
            this.ableClassify = true;
            this.workClassifyList = this.yearWorkClassify;
          } else {
            this.workClassifyList = this.yearWorkClassify.filter(t => t.itemValue == 0 || t.itemValue == 10 || t.itemValue == 50);
          }
        }
      } else if (this.form.type === 'monthwork') {
        this.completeList = this.monthCompleteList;
        //人力 预算等工作不能修改分类
        if (this.form.workClassify == 30 || this.form.workClassify == 40) {
          this.ableClassify = true;
           this.workClassifyList = this.monthWorkClassify;
        }else {
          this.workClassifyList = this.monthWorkClassify.filter(t => t.itemValue != 30 && t.itemValue != 40);
        }
      } else if (this.form.type === 'weekwork') {
        this.completeList = this.weekCompleteList;
        //人力 预算等工作不能修改分类
        if (this.form.workClassify == 30) {
          this.ableClassify = true;
          this.workClassifyList = this.weekWorkClassify;
        }else {
          this.workClassifyList = this.weekWorkClassify.filter(t => t.itemValue != 30);
        }
      } else {
        this.workClassifyList = [];
        this.completeList = [];
      }
      this.$set(this.form, 'workClassify', this.form.workClassify.toString());
      this.$set(this.form, 'completeStatus', this.form.completeStatus.toString());
    },
    confirm() {
      this.$refs.planForm.validate((valid) => {
      if (valid) {
          const form = Object.assign({},this.form, {finishFullTarget: this.form.wholeTarget});
          delete form.status;
          delete form._XID;
          delete form.expandRowFlag;
          delete this.form.completeStatusSort;
          delete this.form.workClassifySort;
          delete this.rowClone.status;
          delete this.rowClone._XID;
          delete this.rowClone.expandRowFlag;
          delete this.rowClone.completeStatusSort;
          delete this.rowClone.workClassifySort;
          this.$ajax.post(this.$api.home.work.createModify, {
            modifyPre: JSON.stringify(this.rowClone),
            modifyAfter: JSON.stringify(form),
          })
          .then(() => {
            this.$message.success('修订提交成功');
            this.getList(1);
            this.showChange = false;
          });
        }
      });
    },
    // eslint-disable-next-line no-unused-vars
    expandRow({ row, rowIndex }) {
      this.tableData[rowIndex].expandRowFlag = !this.tableData[rowIndex].expandRowFlag;
      this.$refs.progress.updateData(this.tableData);
    },
    filterData(res) {
      if (res.data && (this.searchParam.Type === "monthwork" || this.searchParam.Type === "weekwork")) {
        return res.data.rows.filter((t) => t.itemValue !== '50').concat([{itemValue:'1000',itemDesc:'已完成+总目标完成'}]);
      }else if (res.data && this.searchParam.Type === "all") {
        let data = res.data.rows.filter((t) => t.itemValue !== '50').concat([{itemValue:'1000',itemDesc:'已完成+总目标完成'}]);
        data.forEach(v => {
          if (v.itemValue == 20) {
            v.itemDesc = "月/周目标完成";
          }
        })
        return data;
      }else {
        return [];
      }
    },
    weightSearch(queryString, cb) {
      let programList = [{ value: 5 }, { value: 10 }, { value: 15 }, { value: 20 }, { value: 25 }];
      // 调用 callback 返回建议列表的数据
      cb(programList);
    },
    formatDate(value, format) {
      return XEUtils.toDateString(value, format);
    },
    async  getYearWorkClassify() {
      await this.$ajax.get(this.$api.common.getDict, { ItemType: 'YearPlanWorkItemClassify' }).then((res) => {
        if (res.code === 0) {
          this.yearWorkClassify = (res.data && res.data.rows) || [];
        }
      });
    },
    async getMonthWorkClassify() {
     await this.$ajax.get(this.$api.common.getDict, { ItemType: 'MonthWorkItemClassify' }).then((res) => {
        if (res.code === 0) {
          this.monthWorkClassify = (res.data && res.data.rows) || [];
        }
      });
    },
    async  getWeekWorkClassify() {
      await this.$ajax.get(this.$api.common.getDict, { ItemType: 'WeekWorkItemClassify' }).then((res) => {
        if (res.code === 0) {
          this.weekWorkClassify = (res.data && res.data.rows) || [];
        }
      });
    },
    getWeekWorkItemProcessStatus() {
      this.$ajax.get(this.$api.common.getDict, { ItemType: 'WeekWorkItemProcessStatus' }).then((res) => {
        if (res.code === 0) {
          this.weekCompleteList = (res.data && res.data.rows) || [];
        }
      });
    },
    getMonthWorkItemProcessStatus() {
      this.$ajax.get(this.$api.common.getDict, { ItemType: 'MonthWorkItemProcessStatus' }).then((res) => {
        if (res.code === 0) {
          this.monthCompleteList = (res.data && res.data.rows) || [];
        }
      });
    },
    getCategory() {
      this.$ajax.get(this.$api.Identity.Categord.categoryByNo, { userId: sessionStorage.getItem('LOGIN_NAME') }).then((res) => {
        const item = res.data;
        this.categoryList = this.filterCategory(item);
      });
    },
    queryCategory(queryString, cb) {
      let categoryList = this.categoryList;
      // 调用 callback 返回建议列表的数据
      cb(categoryList);
    },
    sortChange(obj) {
      const { property, order } = obj;
      if (property === 'finishDate') {
        this.$set(this.searchParam,'OrderByCompleteStatus','')
        this.$set(this.searchParam,'OrderByWorkClassify','')
        if (order === 'desc') {
          this.$set(this.searchParam,'OrderByFinishDate',1)
        } else {
          this.$set(this.searchParam,'OrderByFinishDate',0)
        }
      }
      if (property === 'completeStatus') {
        this.$set(this.searchParam,'OrderByWorkClassify','')
        this.$set(this.searchParam,'OrderByFinishDate','')
        if (order === 'desc') {
          this.$set(this.searchParam,'OrderByCompleteStatus',1)
        } else {
          this.$set(this.searchParam,'OrderByCompleteStatus',0)
        }
      }
      if (property === 'workClassify') {
        this.$set(this.searchParam,'OrderByCompleteStatus','')
        this.$set(this.searchParam,'OrderByFinishDate','')
        if (order === 'desc') {
          this.$set(this.searchParam,'OrderByWorkClassify',1)
        } else {
          this.$set(this.searchParam,'OrderByWorkClassify',0)
        }
      }
      this.getList(1);
    },
    submitYearSummary(row) {
      this.showYearSummary = true;
      this.summaryForm = _.cloneDeep(row);
      this.$set(this.summaryForm, 'completeStatus', this.summaryForm.completeStatus.toString());
    },
    submitMWSummary(row) {
      this.showMWSummary = true;
      this.summaryForm = _.cloneDeep(row);
      if (this.summaryForm.type === 'monthwork') {
        this.completeList = this.monthCompleteList;
      } else if (this.summaryForm.type === 'weekwork') {
        this.completeList = this.weekCompleteList;
      } else {
        this.completeList = [];
      }
      this.$set(this.summaryForm, 'completeStatus', this.summaryForm.completeStatus.toString());
    },
    workClassifyName(row) {
      if (row.type === 'yearwork') {
        const workClassifyObj=this.yearWorkClassify.find((t) => t.itemValue * 1 === row.workClassify);
        return workClassifyObj? workClassifyObj.itemDesc: '';
      } else if (row.type === 'monthwork') {
        const workClassifyObj=this.monthWorkClassify.find((t) => t.itemValue * 1 === row.workClassify);
        return workClassifyObj? workClassifyObj.itemDesc: '';
      } else if (row.type === 'weekwork') {
        const workClassifyObj=this.weekWorkClassify.find((t) => t.itemValue * 1 === row.workClassify);
        return workClassifyObj? workClassifyObj.itemDesc: '';
      } else {
        return '';
      }
    },
    isShowEdit(row) {
      if (
        (row.type === 'yearwork' && ((row.classify && ![1, 2].includes(row.classify.type)) || row.workClassify === 30 || row.workClassify === 40)) ||
        row.status === 0 || row.status === 10 || row.status === 30
      ) {
        return false;
      } else {
        return true;
      }
    },
    filterWorkType(type) {
      switch (type) {
        case 'yearwork':
          return 0;
        case 'monthwork':
          return 1;
        case 'weekwork':
          return 2;
      }
    },
    isShowTransferOrHandover(row) {
      if (row.type === 'yearwork' && row.currentTarget) {
        if (row.classify) {
          return row.classify.type !== 0;
        } else if (row.workClassify !== 30 && row.workClassify !== 40) {
          return true;
        } else {
          return false;
        }
      } else if ((row.type === 'monthwork'||row.type==='weekwork') && row.currentTarget && row.currentFinishDate) {
        return true;
      } else {
        return false;
      }
    },
    transfer(row) {
      this.showTransFer = true;
      this.transferTitle = "转移工作";
      this.transFerParam.workId = row.workId;
      this.transFerParam.workItemIds = [row.id];
      this.transFerParam.workPlanType = this.filterWorkType(row.type);
      this.transFerParam.planType = 0;
      this.$refs.transferForm && this.$refs.transferForm.resetFields();
    },
    handover(row) {
      this.showTransFer = true;
      this.transferTitle = "交接工作";
      this.transFerParam.workId = row.workId;
      this.transFerParam.workItemIds = [row.id];
      this.transFerParam.workPlanType = this.filterWorkType(row.type);
      this.transFerParam.planType = 1;
      this.$refs.transferForm && this.$refs.transferForm.resetFields();
    },
    getSelecterWkNameData(data) {
      this.seleterWkNameData = data;
    },
    transFerOrHandover() {
      this.transFerParam.designeeName = this.transFerParam.designeeNo
          ? this.seleterWkNameData.find((t) => t.jobNo == this.transFerParam.designeeNo).name
          : '';
      this.$refs.transferForm.validate((valid) => {
        if (valid) {
          this.$ajax.put(this.$api.transfer.planTransfer, this.transFerParam).then((res) => {
            if (res) {
              this.$message.success('提交成功');
              this.showTransFer = false;
              this.closeTransfer();
            }
          });
        } else {
          return false;
        }
      });
    },
    closeTransfer() {
      this.transFerParam = {
        workId: '',
        workItemIds: [],
        designeeNo: '',
        designeeName: '',
        workPlanType: 0,
        planType: 0,
      };
    },
    getListByCompleteStatus(type){
      this.initSearchParam();
      switch(type){
        case 'plan':
        this.$set(this.searchParam,'CompleteStatus','0')
        break;
        case 'processing':
        this.$set(this.searchParam,'CompleteStatus','10')
        break;
        case 'delayed':
        this.$set(this.searchParam,'CompleteStatus','30')
        break;
        case 'transferred':
        this.$set(this.searchParam,'CompleteStatus','40')
        break;
        case 'completed':
        this.$set(this.searchParam,'CompleteStatus','1000')
        break;
      }
      this.getList(1);
    },
    initSearchParam(){
      this.$set(this.searchParam,'WorkItemContent','');
      this.$set(this.searchParam,'Type','');
      this.$set(this.searchParam,'WorkClassify','');
      this.$set(this.searchParam,'CompleteStatus','');
      this.$set(this.searchParam,'FinishDate','');
    },
  },
  watch: {
    'searchParam.Type': {
      handler() {
        this.$set(this.searchParam, 'WorkClassify', '');
      },
      immediate: true,
    },
  },
};
</script>
<style scoped lang="scss">
.progress {
  height: 100%;
  .page-con{
    padding-top: 15px;
  }
  .search {
    margin-top: 0px;
    .el-form-item {
      margin-bottom: 12px;
    }
    .el-date-editor--daterange {
      width: 380px;
      border-radius: 10px;
    }
    overflow: auto;
    .atb-input{
      .flex-wrap{
         display: flex;
        .flex-form-item{
          margin-bottom: 12px;
          display: flex;
          flex: 1;
          width: 25%;
        }
        .read-mode{
          align-self: flex-end;
        }
        ::v-deep.el-form-item__content{
          flex: 1;
          .el-select, .el-autocomplete{
            width: 100%;
          }
        }
      }
    }
  }
  .quick-search {
    margin-bottom: 20px;
    .search-card {
      cursor: pointer;
      flex: 1;
      &:not(:last-child) {
        margin-right: 20px;
      }
      &.plan {
        .num {
          background-color: $--bg-color-delay;
          color: $--color-route-yellow;
        }
      }
      &.working {
        .num {
          background-color: $--bg-color-complete;
          color: $--color-primary;
        }
      }
      &.delay {
        .num {
          background-color: $--bg-color-close;
          color: $--color-warning;
        }
      }
      &.transfer {
        .num {
          background-color: $--bg-color-plan;
          color: $--color-route-blue;
        }
      }
      &.complete {
        .num {
          background-color: $--bg-color-ongoing;
          color: $--color-route-green;
        }
      }
      .num {
        border-radius: 16px;
        width: 80px;
        line-height: 60px;
        font-size: 36px;
        text-align: center;
        margin-right: 20px;
      }
      .text {
        h2 {
          font-size: 18px;
          font-weight: bold;
          color: $--color-text-primary;
        }
        p {
          margin-top: 5px;
          font-size: 14px;
          color: $--color-text-regular;
        }
      }
    }
  }
  .table-content {
    .table {
      flex: 1;
      overflow: auto;
    }
  }
  .el-button {
    &.el-button--primary {
      width: 112px;
      box-shadow: 0 0 5px rgba($--color-primary, 0.4);
    }
    &.el-button--cancel {
      background: $--color-route-yellow;
      border-color: $--color-route-yellow;
      color: $--color-white;
      box-shadow: 0 0 5px rgba($--color-route-yellow, 0.4);
      margin-left: 10px;
    }
  }
  .el-dialog{
    &.route-dialog{
      .content{
        height: 400px;
        overflow: auto;
      }
      .el-dialog__footer{
        padding-top: 6px;
        padding-bottom: 40px;
      }
    }
    &.changeDialog{
      .content{
        height: 500px;
        overflow: auto;
        .el-date-editor, .el-autocomplete{
          width: 100%;
        }
      }
      .el-select{
        width: 100%;
      }
      .write-summary{
        height: 150px;
      }
    }
    &.summaryDialog{
      .el-select{
        width: 100%;
      }
      .write-summary{
        height: 150px;
      }
    }
    &.transferDialog{
      .el-select{
        width: 100%;
      }
    }
  }
  .el-dialog__body {
    .content {
      li {
        padding: 10px 0;
        span.label {
          font-size: 14px;
          color: $--color-text-regular;
          flex: 0 0 64px;
          margin-right: 20px;
          text-align: right;
        }
        .res {
          flex: 1;
          font-weight: bold;
          color: $--color-text-primary;
          font-size: 14px;
          &.name {
            color: $--color-primary;
          }
          &.notice-res {
            font-weight: normal;
            line-height: 1.4;
          }
        }
      }
      ::v-deep .el-form-item__label {
        height: 40px;
        line-height: 1.2;
        display: flex;
        text-align: right;
        align-items: center;
        justify-content: flex-end;
      }
    }
  }
}
</style>
